import { faker } from '@faker-js/faker'

import { AdminPricePropertyListItem, AdminTreatmentPropertyStatus } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminPricePropertyListItem = asBuilder((): AdminPricePropertyListItem => {
  return {
    id: faker.string.uuid(),
    sequentialId: faker.number.int(),
    name: faker.lorem.word(),
    status: faker.helpers.enumValue(AdminTreatmentPropertyStatus),
    values: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      name: faker.lorem.word(),
    })),
  }
})
